import React, { FC } from 'react';
import { SCUIGeneralModal } from '../../../../../atomic/molecules';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SCUIOFSAddToListModal: FC<{
    open: boolean;
    onClose: any;
    searchedText: string;
    setSearchedText: any;
    listele: any;
}> = ({ open, onClose, searchedText, setSearchedText, listele }) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t('general.batchSearch')}
            functionButtonOnClick={listele}
            buttonText={t('general.search')}
        >
            <Grid className="ofs-logs-add-to-list-modal" container sx={{ padding: '2rem' }}>
                <TextField
                    className="ofs-logs-add-to-list-modal-reference-ids"
                    sx={{ paddingBottom: '1rem' }}
                    label={'referenceID'}
                    value={searchedText}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setSearchedText(event.target.value);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                />
            </Grid>
        </SCUIGeneralModal>
    );
};
